import {apiClient} from '@/services/base/BaseService';
import {ITrackingOrder} from '@/models/ITrackingOrder';
import {VPaginationRequestData} from '@/utils/VPaginationRequestData';

export interface IFilterTrackingOrder {
    query: string;
    status: string[];
}

export async function getListTrackingOrders(organizationId: number, shopId: number, filterData: VPaginationRequestData<IFilterTrackingOrder>): Promise<ITrackingOrder[]> {
    const url = `organizations/${organizationId}/shops/${shopId}/tracking-orders`;
    const response = await apiClient.get(url, {
        params: {
            query: filterData.filterData.query,
            status: filterData.filterData.status,
        }
    });
    let trackingOrders = [];
    if (response.status === 200) {
        trackingOrders = response.data.data;
    }
    return trackingOrders;
}

export async function updateTrackingOrderToShopify(organizationId: number, shopId: number, trackingId: number, orderName: string, trackingNumber: string) {
    const url = `organizations/${organizationId}/shops/${shopId}/tracking-orders/${trackingId}/actions/update_to_shopify`;
    const response = await apiClient.post(url, {
        order_name: orderName,
        tracking_number: trackingNumber
    });
    return response;
}
